import React, { useState, useEffect } from 'react';
import axios from 'axios';
import moment from 'moment';
import _ from 'underscore';
import setting from '../../config/setting';
import { Button, Input, Select, Form, DatePicker, Spin, Space, Row, Col, Card, notification, Upload, Modal } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import InputMask from "react-input-mask";
import { useLocation } from 'react-router-dom';
import newLogoIcon from '../../assets/img/wssNewLogo.png';

let i = 1;

const { TextArea } = Input;
const { Option } = Select;
const FormItem = Form.Item;

const New_Order_Form = () => {
    const [form] = Form.useForm();
    const location = useLocation();

    const [locationNewA, setlocationNew] = useState('');
    const [selectedCompany, setSelectedCompany] = useState('');
    const [bool, setBool] = useState(false);
    const [Res, setRes] = useState();
    const [Companyname, setCompanyname] = useState();
    const [legalName, setLegalName] = useState('');
    const [phoneValue, setPhoneValue] = useState('');
    const [emailValue, setEmailValue] = useState('');
    const [Notes, setNotes] = useState('');
    const [bgScreening, setBgScreening] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingForm, setIsLoadingForm] = useState(false);
    const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(true);
    const [reasons, setSelectReason] = useState('');
    const [reasonValue, setReasonValue] = useState();
    const [service_multi_select, setSelectPackage] = useState('');
    const [packageValue, setPackageValue] = useState();
    const [loadingLocations, setLoadingLocations] = useState(false);
    const [loadingReasons, setLoadingReasons] = useState(false);
    const [loadingPkgs, setLoadingPkgs] = useState(false);
    const [orderTypes, setOrderTypes] = useState('new_employee')
    const [typecheckValue, setTypeCheckValue] = useState('');
    const [noRecordFound, setNoRecordFound] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [errMsg, setErrMsg] = useState('');
    const [noRecordMessage, setNoRecordMessage] = useState('No Record Found !');
    const [employeeData, setEmployeeData] = useState([]);
    const [pageSize, setPageSize] = useState(10);
    const [tableType, setTableType] = useState('all');
    const [selectedFiles, setSelectedFiles] = useState([{}]);
    const [fileInputs, setFileInputs] = useState([0]);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [newToken, setNewToken] = useState("");
    const [companyId, setcompanyId] = useState("");
    const [isExpired, setIsExpired] = useState(false);
    const [employees, setEmployees] = useState([{ employeeId: '', legalName: '', jobTitle: '', emailValue: '', phoneValue: '', startDate: '', dateNew: '', emp_ein: '', ssnValue: '', DL: '', }]);

    const handleInputChange = (index, event) => {
        const { name, value } = event.target;
        const updatedEmployees = [...employees];
        updatedEmployees[index][name] = value;
        setEmployees(updatedEmployees);
    };

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const token = params.get("token");
        console.log("Token from location:", token);

        if (token) {
            setNewToken(token);
        }
    }, [location.search]);

    useEffect(() => {
        if (newToken) {
            getNewOrderData();
        }
    }, [newToken]);

    useEffect(() => {
        var typeValue = localStorage.getItem('IdtypeCheckValue');
        setTypeCheckValue(JSON.parse(typeValue));

        form.setFieldsValue({
            // company: companyId
        });
    }, []);

    useEffect(() => {
        if (legalName && locationNewA && phoneValue && emailValue) {
            setIsSaveButtonDisabled(false);
        }
    }, [])

    useEffect(() => {
        var typeValue = localStorage.getItem('IdtypeCheckValue');
        setTypeCheckValue(JSON.parse(typeValue));
    }, [pageSize, tableType]);


    function getNewOrderData() {
        if (!newToken) {
            notification.error({
                message: "Token Missing",
                description: "Token is required to fetch New Order details."
            });
            return;
        }

        setIsLoadingForm(true);

        axios
            .post(setting.serverUrl + "/api/NewOrderForm", {
                params: { token: newToken }
            })
            .then((response) => {
                setIsLoadingForm(false);

                if (!response.data) {
                    notification.error({
                        message: "Invalid Response",
                        description: "Server returned an empty response."
                    });
                    return;
                }

                if (!response.data.data) {
                    notification.error({
                        message: "No Data Found",
                        description: response.data.msg || "No order data available for this token."
                    });
                    return;
                }

                const resData = response.data.data;

                console.log("API Response:", response.data);
                console.log("Fetched Data:", resData);
                console.log("resData.status", resData.status)
                if (resData.status === false) {
                    setIsExpired(true);
                    Modal.warning({
                        title: "Form Expired",
                        content: "Your form link has expired.",
                    });
                    return;
                }

                setRes(resData.location_name || "");
                setlocationNew(resData.location_id || "");
                setCompanyname(resData.company_name || "");
                setcompanyId(resData.company_id || "");
                setReasonValue(resData.reason_name || "");
                setSelectReason(resData.reason_id || "");
                setPackageValue(resData.package_name || "");
                setSelectPackage(resData.package_id || "");
            })
            .catch((err) => {
                setIsLoadingForm(false);
                console.log("API Error:", err);

                notification.error({
                    message: "API Error",
                    description: err.response?.data?.msg || err.message
                });
            });
    }

    const onChangeDate = (index, date, dateString) => {
        const updatedEmployees = [...employees];
        updatedEmployees[index].dateNew = dateString;
        setEmployees(updatedEmployees);
    };

    const onChangeStartDate = (index, date, dateString) => {
        const updatedEmployees = [...employees];
        updatedEmployees[index].startDate = dateString;
        setEmployees(updatedEmployees);
    };

    function locationNew(event) {
        setlocationNew(event);
    }

    const handleEmployeeSelect = (index, employeeId) => {
        setSelectedEmployee(employeeId);
        const selectedEmployeeData = employeeData.find((employee) => employee.id === employeeId);
        let updatedEmployees = [...employees];
        updatedEmployees[index] = {
            employeeId: selectedEmployeeData.id,
            legalName: `${selectedEmployeeData.first_name} ${selectedEmployeeData.last_name}`,
            jobTitle: selectedEmployeeData.Job_Title,
            emailValue: selectedEmployeeData.email,
            phoneValue: selectedEmployeeData.Mobile,
            startDate: selectedEmployeeData.Hire_Rehire_Date ? selectedEmployeeData.Hire_Rehire_Date : null,
            dateNew: selectedEmployeeData.dob ? selectedEmployeeData.dob : null,
            emp_ein: selectedEmployeeData.emp_ein ? selectedEmployeeData.emp_ein : null,
            ssnValue: selectedEmployeeData.emp_ssn ? selectedEmployeeData.emp_ssn : null,
            DL: selectedEmployeeData.DL ? selectedEmployeeData.DL : null,
        };
        setEmployees(updatedEmployees);

        form.setFieldsValue({
            [`legalName-${index}`]: selectedEmployeeData.first_name && selectedEmployeeData.last_name
                ? `${selectedEmployeeData.first_name} ${selectedEmployeeData.last_name}` : '',
            [`jobTitle-${index}`]: selectedEmployeeData.Job_Title || '',
            [`emailValue-${index}`]: selectedEmployeeData.email || '',
            [`phoneValue-${index}`]: selectedEmployeeData.Mobile || '',
            [`startDate-${index}`]: selectedEmployeeData.Hire_Rehire_Date
                ? moment(selectedEmployeeData.Hire_Rehire_Date) : null,
            [`dateNew-${index}`]: selectedEmployeeData.dob
                ? moment(selectedEmployeeData.dob) : null,
            [`emp_ein-${index}`]: selectedEmployeeData.emp_ein || '',
            [`ssnValue-${index}`]: selectedEmployeeData.emp_ssn
                ? `***-**-${selectedEmployeeData.emp_ssn.slice(-4)}` : '',
            [`DL-${index}`]: selectedEmployeeData.DL || ''
        });
    };

    const clearInputField = () => {
        setEmployees([{ employeeId: '', legalName: '', jobTitle: '', emailValue: '', phoneValue: '', startDate: '', dateNew: '', emp_ein: '', ssnValue: '', DL: '' }]);
        setSelectedEmployee('');
        setlocationNew('');
        setBgScreening('');
        setNotes('');
        setSelectReason('');
        setSelectPackage('');
        setSelectedFiles([]);
        setFileInputs([0]);
        form.setFieldsValue({
            emailValue: '',
            phoneValue: '',
            jobTitle: '',
            dateNew: null,
            startDate: null,
            selectedEmployee: '',
            locationNewA: '',
            bgScreening: '',
            Notes: '',
            reasonValue: '',
            employees: '',
            service_multi_select: '',
            packageValue: '',
            selectedFiles: null,
            fileInputs: '',
            emp_ein: '',
            ssnValue: '',
            DL: ''
        });

        form.setFieldsValue({
            [`legalName-0`]: '',
            [`jobTitle-0`]: '',
            [`emailValue-0`]: '',
            [`phoneValue-0`]: '',
            [`emp_ein-0`]: '',
            [`DL-0`]: '',
            [`ssnValue-0`]: '',
            [`selectedEmployee-0`]: '',
            [`startDate-0`]: null,
            [`dateNew-0`]: null,
            [`locationNewA-0`]: '',
            [`reasons-0`]: '',
            [`bgScreening-0`]: '',
            [`Notes-0`]: '',
            [`service_multi_select-0`]: '',
            [`packageValue-0`]: ''
        });

    };


    useEffect(() => {
        setEmployees([{ employeeId: '', legalName: '', jobTitle: '', emailValue: '', phoneValue: '', startDate: '', dateNew: '', emp_ein: '', ssnValue: '', DL: '', }]);
        setSelectedEmployee('');
        form.setFieldsValue({
            [`legalName-0`]: '',
            [`jobTitle-0`]: '',
            [`emailValue-0`]: '',
            [`phoneValue-0`]: '',
            [`selectedEmployee-0`]: '',
            [`startDate-0`]: null,
            [`dateNew-0`]: null,
            [`emp_ein-0`]: '',
            [`DL-0`]: '',
            [`ssnValue-0`]: '',
        });

    }, [orderTypes]);


    function saveEmployee() {
        if (isExpired) {
        Modal.error({
            title: "URL Expired",
            content: "Your form link has expired. You cannot submit this form.",
        });
        return;  
    }
        setIsLoading(true);
        const formdata = new FormData();
        formdata.append('locationNewA', locationNewA);
        formdata.append('comNew', companyId);
        formdata.append('reasons', reasons);
        formdata.append('Notes', Notes);
        formdata.append('employees', JSON.stringify(employees));
        formdata.append('service_multi_select', service_multi_select);
        formdata.append('token', newToken);
        formdata.append('new_employee', 'new_employee');

        (selectedFiles as File[]).forEach((file) => {
            formdata.append("files[]", file);
        });

        const headers = {
            'Content-Type': 'multipart/form-data'
        };

        axios.post(setting.serverUrl + '/api/saveNewEmployee', formdata, { headers })
            .then((response) => {
                console.log('response response', response)
                setIsLoading(false);
                if (response && response.status === 200) {
                    console.log('response.status', response.status)
                    // let id = response.data.id;
                    // let customerData = JSON.parse(localStorage.getItem('customerData'));
                    // customerData.employee_multi_select.push(id);
                    // localStorage.setItem('customerData', JSON.stringify(customerData));
                    clearInputField();
                    form.resetFields();
                    setSelectedFiles([]);
                    if (response.data.error === 'Technical Issue') {
                        notification.error({
                            message: 'Failed to retrieve data at the moment. Please try again in a bit.'
                        });
                    } else {
                        notification.success({
                            message: 'Request Sent Successfully!'
                        });
                        setIsSaveButtonDisabled(true);
                    }
                }
            })
            .catch((error) => {
                setIsLoading(false);
                notification.error({
                    message: 'Error',
                    description: 'There was an issue saving the employee. Please try again later.'
                });
            });
    }

    function reasonSelection(event, value) {
        setSelectReason(event);
    }

    const handleAddFileInput = () => {
        setFileInputs([...fileInputs, fileInputs.length]);
    };

    const handleFileChange = (fileList, index) => {
        setSelectedFiles(fileList?.map(val => val?.originFileObj));
    };

    const handleAddRow = () => {
        setEmployees([...employees, { employeeId: '', legalName: '', jobTitle: '', emailValue: '', phoneValue: '', startDate: '', dateNew: '', emp_ein: '', ssnValue: '', DL: '', }]);
        form.setFieldsValue({
            [`legalName-${employees?.length}`]: '',
            [`jobTitle-${employees?.length}`]: '',
            [`emailValue-${employees?.length}`]: '',
            [`phoneValue-${employees?.length}`]: '',
            [`emp_ein-${employees?.length}`]: '',
            [`DL-${employees?.length}`]: '',
            [`ssnValue-${employees?.length}`]: '',
            [`startDate-${employees?.length}`]: null,
            [`dateNew-${employees?.length}`]: null,
            [`selectedEmployee-${employees?.length}`]: '',
        });
    };

    const handleUploadChange = (info, index) => {
        handleFileChange(info?.fileList, index);
    };

    const handleRemoveRow = (index) => {
        const newEmployees = employees.filter((_, idx) => idx !== index);
        setEmployees(newEmployees);

        form.setFieldsValue({
            [`legalName-${index}`]: '',
            [`jobTitle-${index}`]: '',
            [`emailValue-${index}`]: '',
            [`phoneValue-${index}`]: '',
            [`emp_ein-${index}`]: '',
            [`DL-${index}`]: '',
            [`ssnValue-${index}`]: '',
            [`startDate-${index}`]: null,
            [`dateNew-${index}`]: null,
            [`selectedEmployee-${index}`]: '',
        });

        newEmployees.forEach((_, idx) => {
            form.setFieldsValue({
                [`legalName-${idx}`]: form.getFieldValue(`legalName-${idx + (idx >= index ? 1 : 0)}`) || '',
                [`jobTitle-${idx}`]: form.getFieldValue(`jobTitle-${idx + (idx >= index ? 1 : 0)}`) || '',
                [`emailValue-${idx}`]: form.getFieldValue(`emailValue-${idx + (idx >= index ? 1 : 0)}`) || '',
                [`phoneValue-${idx}`]: form.getFieldValue(`phoneValue-${idx + (idx >= index ? 1 : 0)}`) || '',
                [`emp_ein-${idx}`]: form.getFieldValue(`emp_ein-${idx + (idx >= index ? 1 : 0)}`) || '',
                [`DL-${idx}`]: form.getFieldValue(`DL-${idx + (idx >= index ? 1 : 0)}`) || '',
                [`ssnValue-${idx}`]: form.getFieldValue(`ssnValue-${idx + (idx >= index ? 1 : 0)}`) || '',
                [`startDate-${idx}`]: form.getFieldValue(`startDate-${idx + (idx >= index ? 1 : 0)}`) || null,
                [`dateNew-${idx}`]: form.getFieldValue(`dateNew-${idx + (idx >= index ? 1 : 0)}`) || null,
                [`selectedEmployee-${idx}`]: form.getFieldValue(`selectedEmployee-${idx + (idx >= index ? 1 : 0)}`) || '',
            });
        });
    };
    if (isLoadingForm) {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                }}
            >
                <Spin size="large" />
            </div>
        );
    }

    return (
        <div
            style={{
                padding: 24,
                maxHeight: "100vh",
                overflowY: "auto",
                background: "#f5f7fa",
            }}
        >
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}
            >

                <h3 style={{ color: "#1C3A6A", margin: 0 }}>New Order</h3>

                <div style={{ flex: 1, textAlign: "center" }}>
                    <img
                        src={newLogoIcon}
                        alt="Logo"
                        style={{ width: 120, height: "auto" }}
                    />
                </div>

                <div style={{ width: 120 }}></div>
            </div>


            <Card
                style={{
                    borderRadius: 12,
                    padding: 20,
                    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                }}
            >
                <Form
                    layout="vertical"
                    form={form}
                    onFinish={saveEmployee}
                    onValuesChange={() => {
                        form
                            .validateFields([
                                "legalName",
                                "locationNewA",
                                "phoneValue",
                                "emailValue",
                            ])
                            .then(() => setIsSaveButtonDisabled(false))
                            .catch(() => setIsSaveButtonDisabled(true));
                    }}
                >

                    <h4 style={{ color: "#1C3A6A", marginBottom: 16 }}>Order Details</h4>

                    <Row gutter={20}>
                        <Col span={12}>
                            <p style={{ fontSize: '15px', fontWeight: 600, marginBottom: '15px' }}>
                                Company Name : <span style={{ fontWeight: 400 }}>{Companyname}</span>
                            </p>
                        </Col>

                        <Col span={12}>
                            <p style={{ fontSize: '15px', fontWeight: 600, marginBottom: '15px' }}>
                                Company Location : <span style={{ fontWeight: 400 }}>{Res}</span>
                            </p>
                        </Col>

                        <Col span={12}>
                            <p style={{ fontSize: '15px', fontWeight: 600, marginBottom: '15px' }}>
                                Reason : <span style={{ fontWeight: 400 }}>{reasonValue}</span>

                            </p>
                        </Col>

                        <Col span={12}>
                            <p style={{ fontSize: '15px', fontWeight: 600, marginBottom: '15px' }}>
                                Package : <span style={{ fontWeight: 400 }}>{packageValue}</span>
                            </p>
                        </Col>

                        <Col span={12}>
                            <FormItem label="Notes" name="Notes" style={{ marginTop: '25px' }}>
                                <TextArea
                                    rows={3}
                                    placeholder="Enter notes"
                                    value={Notes}
                                    onChange={(e) => setNotes(e.target.value)}
                                />
                            </FormItem>
                        </Col>
                    </Row>


                    <h3 style={{ color: "#1C3A6A", marginTop: 24 }}>Employee(s)</h3>

                    {employees.map((employee, index) => (
                        <Card
                            key={index}
                            style={{
                                marginBottom: 16,
                                borderRadius: 10,
                                background: "#ffffff",
                                boxShadow: "0px 2px 10px rgba(0,0,0,0.05)",
                            }}
                        >
                            <div style={{ textAlign: "right" }}>
                                <i
                                    onClick={() => handleRemoveRow(index)}
                                    className="fa fa-times-circle"
                                    style={{
                                        fontSize: 20,
                                        cursor: "pointer",
                                        color: "#d9534f",
                                    }}
                                ></i>
                            </div>

                            <Row gutter={20}>
                                <Col span={6}>
                                    <Form.Item label="Employee Name" name={`legalName-${index}`}>
                                        <Input
                                            placeholder="Enter name"
                                            name="legalName"
                                            value={employee.legalName}
                                            onChange={(e) => handleInputChange(index, e)}
                                        />
                                    </Form.Item>
                                </Col>


                                <Col span={6}>
                                    <FormItem label="EIN" name={`emp_ein-${index}`}>
                                        <Input
                                            placeholder="Enter EIN"
                                            name="emp_ein"
                                            value={employee.emp_ein}
                                            onChange={(e) => handleInputChange(index, e)}
                                            disabled={!!selectedEmployee}
                                        />
                                    </FormItem>
                                </Col>

                                <Col span={6}>
                                    <FormItem label="SSN" name={`ssnValue-${index}`}>
                                        <InputMask
                                            mask="999-99-9999"
                                            value={employee.ssnValue}
                                            onChange={(e) => handleInputChange(index, e)}
                                            disabled={!!selectedEmployee}
                                        >
                                            {(p) => (
                                                <Input {...p} placeholder="___-__-____" name="ssnValue" />
                                            )}
                                        </InputMask>
                                    </FormItem>
                                </Col>

                                <Col span={6}>
                                    <FormItem label="DL" name={`DL-${index}`}>
                                        <Input
                                            placeholder="Enter DL"
                                            name="DL"
                                            value={employee.DL}
                                            onChange={(e) => handleInputChange(index, e)}
                                            disabled={!!selectedEmployee}
                                        />
                                    </FormItem>
                                </Col>

                                <Col span={6}>
                                    <FormItem label="DOB" name={`dateNew-${index}`}>
                                        <DatePicker
                                            style={{ width: "100%" }}
                                            placeholder="Select date"
                                            value={
                                                employee.dateNew ? moment(employee.dateNew) : null
                                            }
                                            onChange={(d, ds) => onChangeDate(index, d, ds)}
                                            disabled={!!selectedEmployee}
                                        />
                                    </FormItem>
                                </Col>

                                <Col span={6}>
                                    <FormItem label="Job Title" name={`jobTitle-${index}`}>
                                        <Input
                                            placeholder="Job Title"
                                            name="jobTitle"
                                            value={employee.jobTitle}
                                            onChange={(e) => handleInputChange(index, e)}
                                            disabled={!!selectedEmployee}
                                        />
                                    </FormItem>
                                </Col>

                                <Col span={6}>
                                    <FormItem label="Email" name={`emailValue-${index}`}>
                                        <Input
                                            placeholder="Enter Email"
                                            name="emailValue"
                                            value={employee.emailValue}
                                            onChange={(e) => handleInputChange(index, e)}
                                            disabled={!!selectedEmployee}
                                        />
                                    </FormItem>
                                </Col>

                                <Col span={6}>
                                    <FormItem label="Phone" name={`phoneValue-${index}`}>
                                        <Input
                                            placeholder="Enter Phone"
                                            name="phoneValue"
                                            value={employee.phoneValue}
                                            onChange={(e) => handleInputChange(index, e)}
                                            disabled={!!selectedEmployee}
                                        />
                                    </FormItem>
                                </Col>

                                {orderTypes === "new_employee" && (
                                    <Col span={6}>
                                        <FormItem label="Start Date" name={`startDate-${index}`}>
                                            <DatePicker
                                                style={{ width: "100%" }}
                                                placeholder="Start Date"
                                                value={
                                                    employee.startDate
                                                        ? moment(employee.startDate)
                                                        : null
                                                }
                                                onChange={(d, ds) => onChangeStartDate(index, d, ds)}
                                                disabled={!!selectedEmployee}
                                            />
                                        </FormItem>
                                    </Col>
                                )}
                            </Row>
                        </Card>
                    ))}

                    <Button
                        type="primary"
                        style={{ background: "#1C3A6A", marginBottom: 20 }}
                        onClick={handleAddRow}
                    >
                        + Add Employee
                    </Button>

                    <h3 style={{ color: "#1C3A6A" }}>Attachments</h3>

                    {fileInputs.map((input, index) => (
                        <Form.Item
                            label="File"
                            name={`selectedFiles_${index}`}
                            key={index}
                        >
                            <Upload
                                listType="picture"
                                accept="image/jpeg,image/png,image/gif,application/pdf"
                                onChange={(info) => handleUploadChange(info, index)}
                            >
                                <Button
                                    type="primary"
                                    style={{ background: "#1C3A6A" }}
                                    icon={<UploadOutlined />}
                                >
                                    Upload
                                </Button>
                            </Upload>
                        </Form.Item>
                    ))}

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            marginTop: 20,
                            marginBottom: 25
                        }}
                    >
                        <Button
                            type="primary"
                            htmlType="submit"
                            disabled={isSaveButtonDisabled}
                            style={{ background: "#1C3A6A", height: '50px', width: '150px', fontWeight: 600, fontSize: '16px' }}
                        >
                            Submit
                        </Button>
                        {isLoading && <Spin size="large" style={{marginLeft:'10px'}}/>}
                    </div>


                    {/* {isLoading && (
                        <Space size="middle" style={{ marginLeft: 10 }}>
                            <Spin size="large" />
                        </Space>
                    )} */}
                </Form>
            </Card>
        </div>

    )

};

export default New_Order_Form;
